export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7975.42f4c76d.jpg";